import React, { useState, createContext, useEffect } from 'react'
import { formalitiesStatusDefaultValues } from '../components/Table/config'

export const VariablesContext = createContext({} as any)

const VariablesContextProvider = (props: any) => {
  const storedVariables = sessionStorage.getItem('filters')
  const initialVariables = storedVariables
    ? JSON.parse(storedVariables)
    : {
        pagination: { current: 1, pageSize: 10 },
        filters: {
          purchaseStatus: ['paid'],
          legalFormalityStatus: formalitiesStatusDefaultValues(),
        },
        search: { value: null },
        sorter: { field: 'createdAt', order: 'descend' },
      }

  const [variables, setVariables] = useState<any>(initialVariables)

  useEffect(() => {
    if (storedVariables) {
      setVariables(initialVariables)
    }
  }, [storedVariables])

  const direction = (order: string | undefined) =>
    order === 'descend' ? 'desc' : 'asc'

  const apiParameters = () => ({
    pagination: {
      page: variables.pagination.current,
      pageLength: variables.pagination.pageSize,
    },
    sorter: variables.sorter?.order
      ? {
          field: variables.sorter.field,
          direction: direction(variables.sorter?.order),
        }
      : null,
    filters: variables.filters
      ? Object.entries(variables.filters)
          .map(item => (item[1] ? { field: item[0], values: item[1] } : null))
          .filter(n => n)
      : null,
    search: variables.search,
  })

  return (
    <VariablesContext.Provider
      value={{
        variables: variables,
        setVariables: setVariables,
        apiParameters: apiParameters,
      }}
    >
      {props.children}
    </VariablesContext.Provider>
  )
}

export default VariablesContextProvider
